(function(){
  var sectionRoot = document.querySelector("[data-rp-axle-inventory]");
  if (!sectionRoot || sectionRoot.dataset.rpInitialized === "true") return;
  sectionRoot.dataset.rpInitialized = "true";

  var csvUrl = sectionRoot.getAttribute("data-csv-url");
  if (!csvUrl) return;

  var table = document.getElementById("rpAxleTable");
  var tableHead = table ? table.querySelector("thead") : null;
  var tableBody = table ? table.querySelector("tbody") : null;
  var cards = document.getElementById("rpAxleCards");
  var searchInput = document.getElementById("rpAxleSearch");
  var statusFilter = document.getElementById("rpAxleStatus");
  var loading = document.getElementById("rpAxleLoading");
  var error = document.getElementById("rpAxleError");
  var noResults = document.getElementById("rpAxleNoResults");
  var count = document.getElementById("rpAxleCount");
  var updated = document.getElementById("rpAxleUpdated");

  var compareBar = document.getElementById("rpAxleCompareBar");
  var compareCount = document.getElementById("rpCompareCount");
  var compareOpen = document.getElementById("rpCompareOpen");
  var compareClear = document.getElementById("rpCompareClear");
  var comparePanel = document.getElementById("rpComparePanel");
  var compareClose = document.getElementById("rpCompareClose");
  var compareTableWrap = document.getElementById("rpCompareTableWrap");

  var finderCapacity = document.getElementById("rpFinderCapacity");
  var finderType = document.getElementById("rpFinderType");
  var finderBrake = document.getElementById("rpFinderBrake");
  var finderBolt = document.getElementById("rpFinderBolt");
  var finderHubFace = document.getElementById("rpFinderHubFace");
  var finderSpringCenter = document.getElementById("rpFinderSpringCenter");
  var finderReset = document.getElementById("rpAxleFinderReset");

  var chipButtons = document.querySelectorAll(".rp-filter-chip");
  var clearChips = document.getElementById("rpClearChips");

  var rows = [];
  var rawHeaders = [];
  var selectedCompareIds = [];
  var activeChips = {};
  var openDetails = {};

  var sortState = {
    index: null,
    direction: "asc"
  };

  var publicColumns = [
    {
      label: "Compare",
      aliases: [],
      type: "compare",
      synthetic: true
    },
    {
      label: "Status",
      aliases: ["FB Status", "Status", "Listing Status"],
      type: "status",
      synthetic: true
    },
    {
      label: "Qty",
      aliases: ["QTY", "Qty", "Quantity"],
      type: "qty"
    },
    {
      label: "Capacity",
      aliases: ["#", "Number", "Capacity", "Rating"],
      type: "capacity"
    },
    {
      label: "Title",
      aliases: [
        "TITLE",
        "Title",
        "FB Marketplace Wording / Title",
        "FB Marketplace Wording",
        "Marketplace Title"
      ],
      type: "title"
    },
    {
      label: "R&P SKU",
      aliases: ["R&P SKU", "RP SKU", "SKU"],
      type: "text"
    },
    {
      label: "Notes / Decode",
      aliases: [
        "Notes / Decode",
        "Notes/Decode",
        "Decode",
        "Description",
        "Notes"
      ],
      type: "notes"
    },
    {
      label: "Price",
      aliases: ["Price"],
      type: "price"
    },
    {
      label: "FB Marketplace Link",
      aliases: [
        "FB Marketplace Link",
        "Marketplace Link",
        "FB Link",
        "FB URL",
        "Facebook Marketplace Link"
      ],
      type: "link"
    }
  ];

  var sourceColumns = {
    platform: ["Source Platform", "Source"],
    record: ["Source Record", "Source Reference"],
    dexter: [
      "Dexter / Original Part Number",
      "Dexter Part Number",
      "Original Part Number"
    ],
    invoice: ["Source Invoice Number", "Invoice Number"],
    invoiceDate: ["Source Invoice Date", "Invoice Date"],
    batchDate: ["Data Batch Date", "Batch Date"],
    verified: ["Last Verified", "Verified Date"],
    shopify: ["Shopify URL", "Shopify Link"],
    ebay: ["eBay URL", "eBay Link"]
  };

  function findAliasValue(row, aliases) {
    return findValue(row, {
      aliases: aliases || []
    });
  }

  function parseCSV(text) {
    var result = [];
    var row = [];
    var value = "";
    var insideQuotes = false;

    for (var i = 0; i < text.length; i++) {
      var char = text[i];
      var nextChar = text[i + 1];

      if (char === '"' && insideQuotes && nextChar === '"') {
        value += '"';
        i++;
      } else if (char === '"') {
        insideQuotes = !insideQuotes;
      } else if (char === "," && !insideQuotes) {
        row.push(value);
        value = "";
      } else if ((char === "\n" || char === "\r") && !insideQuotes) {
        if (value || row.length) {
          row.push(value);
          result.push(row);
          row = [];
          value = "";
        }

        if (char === "\r" && nextChar === "\n") {
          i++;
        }
      } else {
        value += char;
      }
    }

    if (value || row.length) {
      row.push(value);
    }

    if (row.length) {
      result.push(row);
    }

    return result;
  }

  function cleanCell(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalizeKey(value) {
    return cleanCell(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "");
  }

  function escapeHTML(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function findHeaderRow(csv) {
    for (var i = 0; i < csv.length; i++) {
      var normalizedHeaders = csv[i].map(function(cell){
        return normalizeKey(cell);
      });

      var hasQty =
        normalizedHeaders.indexOf("qty") !== -1 ||
        normalizedHeaders.indexOf("quantity") !== -1;

      var hasTitle =
        normalizedHeaders.indexOf("title") !== -1 ||
        normalizedHeaders.indexOf("fbmarketplacewordingtitle") !== -1;

      var hasSku =
        normalizedHeaders.indexOf("rpsku") !== -1 ||
        normalizedHeaders.indexOf("sku") !== -1;

      var hasPrice =
        normalizedHeaders.indexOf("price") !== -1;

      var hasFbLink =
        normalizedHeaders.indexOf("fbmarketplacelink") !== -1 ||
        normalizedHeaders.indexOf("marketplacelink") !== -1 ||
        normalizedHeaders.indexOf("fblink") !== -1;

      if (hasQty && hasTitle && hasSku && hasPrice) return i;
      if (hasQty && hasSku && hasFbLink) return i;
    }

    return 0;
  }

  function findValue(row, columnConfig) {
    if (!columnConfig || !columnConfig.aliases) return "";

    for (var i = 0; i < columnConfig.aliases.length; i++) {
      var aliasKey = normalizeKey(columnConfig.aliases[i]);

      for (var key in row) {
        if (normalizeKey(key) === aliasKey) {
          return cleanCell(row[key]);
        }
      }
    }

    return "";
  }

  function allRowText(row) {
    var parts = [];

    for (var key in row) {
      parts.push(row[key]);
    }

    publicColumns.forEach(function(column){
      parts.push(findValue(row, column));
    });

    return parts.join(" ").toLowerCase();
  }

  function rowText(row) {
    return publicColumns.map(function(column){
      return findValue(row, column);
    }).join(" ").toLowerCase();
  }

  function getPrimaryTitle(row) {
    return findValue(row, publicColumns[4]) ||
      findValue(row, publicColumns[6]) ||
      findValue(row, publicColumns[5]) ||
      findValue(row, publicColumns[3]) ||
      "Trailer Axle";
  }

  function isURL(value) {
    return /^(https?:\/\/|www\.)/i.test(cleanCell(value));
  }

  function numberFromValue(value) {
    var cleaned = cleanCell(value).replace(/[^0-9.-]/g, "");
    var parsed = parseFloat(cleaned);

    return isNaN(parsed) ? 0 : parsed;
  }

  function formatPrice(value) {
    var cleaned = cleanCell(value);

    if (!cleaned || cleaned === "$") return "";

    var parsed = numberFromValue(cleaned);

    if (!parsed) return cleaned;

    return "$" + parsed.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function rowId(row, index) {
    var sku = findValue(row, publicColumns[5]);
    var title = getPrimaryTitle(row);

    return normalizeKey(sku + "-" + title + "-" + index);
  }

  function makeCustomerStatus(value) {
    var status = cleanCell(value).toLowerCase();

    if (
      status.indexOf("link found") !== -1 ||
      status.indexOf("active") !== -1
    ) {
      return "Marketplace Listing Available";
    }

    if (status.indexOf("draft") !== -1) {
      return "Drafted";
    }

    if (
      status.indexOf("priced") !== -1 ||
      status.indexOf("ready") !== -1
    ) {
      return "Ready to Confirm";
    }

    if (status.indexOf("hold") !== -1) {
      return "On Hold";
    }

    if (
      status.indexOf("sold") !== -1 ||
      status.indexOf("gone") !== -1
    ) {
      return "Sold";
    }

    if (!value) {
      return "Call to Confirm";
    }

    return value;
  }

  function getStatusClass(value) {
    var status = cleanCell(value).toLowerCase();

    if (
      status.indexOf("link found") !== -1 ||
      status.indexOf("active") !== -1
    ) {
      return "rp-status-pill rp-status-pill--linked";
    }

    if (status.indexOf("draft") !== -1) {
      return "rp-status-pill rp-status-pill--draft";
    }

    if (
      status.indexOf("priced") !== -1 ||
      status.indexOf("ready") !== -1
    ) {
      return "rp-status-pill rp-status-pill--ready";
    }

    if (status.indexOf("hold") !== -1) {
      return "rp-status-pill rp-status-pill--hold";
    }

    if (
      status.indexOf("sold") !== -1 ||
      status.indexOf("gone") !== -1
    ) {
      return "rp-status-pill rp-status-pill--sold";
    }

    return "rp-status-pill";
  }

  function makeStatusPill(value) {
    return (
      '<span class="' +
      getStatusClass(value) +
      '">' +
      escapeHTML(makeCustomerStatus(value)) +
      "</span>"
    );
  }

  function makeQty(value) {
    var qty = numberFromValue(value);
    var output = escapeHTML(value);

    if (qty === 1) {
      output += '<span class="rp-low-qty">Only 1</span>';
      output +=
        '<span class="rp-qty-meter rp-qty-meter--low">' +
        "&#9608;&#9633;&#9633;&#9633;&#9633;" +
        "</span>";
    } else if (qty > 1 && qty < 5) {
      output +=
        '<span class="rp-qty-meter">' +
        "&#9608;&#9608;&#9608;&#9633;&#9633;" +
        "</span>";
    } else if (qty >= 5) {
      output +=
        '<span class="rp-qty-meter">' +
        "&#9608;&#9608;&#9608;&#9608;&#9608;" +
        "</span>";
    }

    return output;
  }

  function extractCapacity(text) {
    var lower = text.toLowerCase();

    var patterns = [
      {
        value: "15000",
        test: /(15000|15,000|15k)/
      },
      {
        value: "12000",
        test: /(12000|12,000|12k)/
      },
      {
        value: "10000",
        test: /(10000|10,000|10k)/
      },
      {
        value: "8000",
        test: /(8000|8,000|8k)/
      },
      {
        value: "7000",
        test: /(7000|7,000|7k)/
      },
      {
        value: "6000",
        test: /(6000|6,000|6k)/
      },
      {
        value: "5200",
        test: /(5200|5,200|5\.2k)/
      },
      {
        value: "3500",
        test: /(3500|3,500|3\.5k)/
      },
      {
        value: "2000",
        test: /(2000|2,000|2k)/
      },
      {
        value: "600",
        test: /(^|\D)600(\D|$)/
      }
    ];

    for (var i = 0; i < patterns.length; i++) {
      if (patterns[i].test.test(lower)) {
        return patterns[i].value;
      }
    }

    return "";
  }

  function extractType(text) {
    var lower = text.toLowerCase();

    if (
      lower.indexOf("torsion") !== -1 ||
      lower.indexOf("torflex") !== -1
    ) {
      return "Torsion";
    }

    if (
      lower.indexOf("beam") !== -1 ||
      lower.indexOf("spring") !== -1 ||
      lower.indexOf("sc") !== -1
    ) {
      return "Beam";
    }

    return "";
  }

  function extractBrake(text) {
    var lower = text.toLowerCase();

    if (
      lower.indexOf("idler") !== -1 ||
      lower.indexOf("no brake") !== -1 ||
      lower.indexOf("no drums") !== -1
    ) {
      return "Idler";
    }

    if (lower.indexOf("disc") !== -1) {
      return "Disc";
    }

    if (lower.indexOf("hydraulic") !== -1) {
      return "Hydraulic";
    }

    if (
      lower.indexOf("electric") !== -1 ||
      lower.indexOf("elec") !== -1
    ) {
      return "Electric";
    }

    if (lower.indexOf("drum") !== -1) {
      return "Drum";
    }

    return "";
  }

  function extractBolt(text) {
    var lower = text.toLowerCase();

    if (
      lower.indexOf("8 on 275") !== -1 ||
      lower.indexOf("8on275") !== -1 ||
      lower.indexOf("8275") !== -1
    ) {
      return "8 on 275mm";
    }

    if (
      lower.indexOf("8 on 6.5") !== -1 ||
      lower.indexOf("8on6.5") !== -1 ||
      lower.indexOf("865") !== -1
    ) {
      return "8 on 6.5";
    }

    if (
      lower.indexOf("6 on 5.5") !== -1 ||
      lower.indexOf("6on5.5") !== -1 ||
      lower.indexOf("655") !== -1
    ) {
      return "6 on 5.5";
    }

    if (
      lower.indexOf("5 on 4.5") !== -1 ||
      lower.indexOf("5on4.5") !== -1 ||
      lower.indexOf("545") !== -1
    ) {
      return "5 on 4.5";
    }

    return "";
  }

  function extractMeasurement(text, kind) {
    var lower = text.toLowerCase();
    var match;

    if (kind === "hub") {
      match = lower.match(
        /(\d+(?:\.\d+)?)\s*(?:["\u201D])?\s*(?:hf|hub face)/i
      );

      if (match) {
        return match[1];
      }

      match = lower.match(
        /(?:hf|hub face)[^\d]*(\d+(?:\.\d+)?)/i
      );

      if (match) {
        return match[1];
      }
    }

    if (kind === "spring") {
      match = lower.match(
        /(\d+(?:\.\d+)?)\s*(?:["\u201D])?\s*(?:sc|spring center|lprv|dn|bracket)/i
      );

      if (match) {
        return match[1];
      }

      match = lower.match(
        /(?:sc|spring center|lprv|dn|bracket)[^\d]*(\d+(?:\.\d+)?)/i
      );

      if (match) {
        return match[1];
      }
    }

    return "";
  }

  function getSpecs(row) {
    var text = allRowText(row);
    var rawCapacity = findValue(row, publicColumns[3]);

    return {
      capacity: extractCapacity(rawCapacity + " " + text),
      type: extractType(text),
      brake: extractBrake(text),
      bolt: extractBolt(text),
      hub: extractMeasurement(text, "hub"),
      spring: extractMeasurement(text, "spring")
    };
  }

  function makeSpecBadges(row) {
    var specs = getSpecs(row);
    var badges = [];

    if (specs.capacity) {
      badges.push(
        Number(specs.capacity).toLocaleString() + " lb"
      );
    }

    if (specs.hub) {
      badges.push(specs.hub + '" HF');
    }

    if (specs.spring) {
      badges.push(specs.spring + '" SC');
    }

    if (specs.brake) {
      badges.push(specs.brake);
    }

    if (specs.bolt) {
      badges.push(specs.bolt);
    }

    if (specs.type) {
      badges.push(specs.type);
    }

    if (!badges.length) {
      return "";
    }

    return (
      '<div class="rp-spec-badges">' +
      badges.map(function(badge){
        return (
          '<span class="rp-spec-badge">' +
          escapeHTML(badge) +
          "</span>"
        );
      }).join("") +
      "</div>"
    );
  }

  function hasMatchingChip(row, chipType, chipValue) {
    var specs = getSpecs(row);
    var text = allRowText(row);

    if (chipType === "capacity") {
      return (
        specs.capacity === chipValue ||
        text.indexOf(chipValue) !== -1
      );
    }

    if (chipType === "type") {
      return specs.type.toLowerCase() === chipValue;
    }

    if (chipType === "brake") {
      return (
        specs.brake.toLowerCase() === chipValue ||
        text.indexOf(chipValue) !== -1
      );
    }

    if (chipType === "bolt") {
      return (
        specs.bolt
          .toLowerCase()
          .indexOf(chipValue.toLowerCase()) !== -1 ||
        text.indexOf(chipValue.toLowerCase()) !== -1
      );
    }

    return true;
  }

  function finderMatches(row) {
    var specs = getSpecs(row);
    var text = allRowText(row);

    if (finderCapacity && finderCapacity.value) {
      if (
        specs.capacity !== finderCapacity.value &&
        text.indexOf(finderCapacity.value) === -1
      ) {
        return false;
      }
    }

    if (finderType && finderType.value) {
      if (specs.type.toLowerCase() !== finderType.value) {
        return false;
      }
    }

    if (finderBrake && finderBrake.value) {
      if (
        specs.brake.toLowerCase() !== finderBrake.value &&
        text.indexOf(finderBrake.value) === -1
      ) {
        return false;
      }
    }

    if (finderBolt && finderBolt.value) {
      if (
        specs.bolt
          .toLowerCase()
          .indexOf(finderBolt.value.toLowerCase()) === -1 &&
        text.indexOf(finderBolt.value.toLowerCase()) === -1
      ) {
        return false;
      }
    }

    if (
      finderHubFace &&
      finderHubFace.value.trim()
    ) {
      var hubSearch = numberFromValue(finderHubFace.value);

      if (hubSearch && specs.hub) {
        if (
          Math.abs(
            numberFromValue(specs.hub) - hubSearch
          ) > 0.25
        ) {
          return false;
        }
      } else if (
        hubSearch &&
        text.indexOf(String(hubSearch)) === -1
      ) {
        return false;
      }
    }

    if (
      finderSpringCenter &&
      finderSpringCenter.value.trim()
    ) {
      var springSearch = numberFromValue(
        finderSpringCenter.value
      );

      if (springSearch && specs.spring) {
        if (
          Math.abs(
            numberFromValue(specs.spring) - springSearch
          ) > 0.25
        ) {
          return false;
        }
      } else if (
        springSearch &&
        text.indexOf(String(springSearch)) === -1
      ) {
        return false;
      }
    }

    return true;
  }

  function shouldShowRow(row) {
    return publicColumns.some(function(column){
      if (
        column.type === "status" ||
        column.type === "compare"
      ) {
        return false;
      }

      return !!findValue(row, column);
    });
  }

  function populateStatusOptions() {
    var seen = {};

    statusFilter.innerHTML =
      '<option value="">All Statuses</option>';

    rows.forEach(function(row){
      var rawStatus = findValue(row, publicColumns[1]);

      if (!rawStatus) {
        return;
      }

      var publicStatus = makeCustomerStatus(rawStatus);

      if (publicStatus) {
        seen[publicStatus] = rawStatus;
      }
    });

    Object.keys(seen)
      .sort()
      .forEach(function(publicStatus){
        var option = document.createElement("option");

        option.value = seen[publicStatus];
        option.textContent = publicStatus;

        statusFilter.appendChild(option);
      });
  }

  function getFilteredRows() {
    var query = searchInput.value
      .toLowerCase()
      .trim();

    var status = statusFilter.value;

    var filtered = rows.filter(function(row){
      var matchesSearch =
        !query ||
        rowText(row).indexOf(query) !== -1 ||
        allRowText(row).indexOf(query) !== -1;

      var rowStatus = findValue(row, publicColumns[1]);

      var matchesStatus =
        !status ||
        rowStatus === status;

      var matchesFinder = finderMatches(row);
      var matchesChips = true;

      Object.keys(activeChips).forEach(function(chipType){
        if (
          !activeChips[chipType] ||
          !activeChips[chipType].length
        ) {
          return;
        }

        var typeMatch = activeChips[chipType].some(
          function(chipValue){
            return hasMatchingChip(
              row,
              chipType,
              chipValue
            );
          }
        );

        if (!typeMatch) {
          matchesChips = false;
        }
      });

      return (
        matchesSearch &&
        matchesStatus &&
        matchesFinder &&
        matchesChips
      );
    });

    if (sortState.index !== null) {
      var column = publicColumns[sortState.index];

      filtered.sort(function(a, b){
        var aValue = findValue(a, column);
        var bValue = findValue(b, column);
        var result;

        if (
          column.type === "qty" ||
          column.type === "price" ||
          column.type === "capacity"
        ) {
          result =
            numberFromValue(aValue) -
            numberFromValue(bValue);
        } else {
          result = aValue.localeCompare(
            bValue,
            undefined,
            {
              numeric: true,
              sensitivity: "base"
            }
          );
        }

        return sortState.direction === "asc"
          ? result
          : -result;
      });
    }

    return filtered;
  }

  function renderCellValue(
    column,
    value,
    row,
    rowIndex
  ) {
    if (column.type === "compare") {
      var id = rowId(row, rowIndex);

      var checked =
        selectedCompareIds.indexOf(id) !== -1
          ? " checked"
          : "";

      return (
        '<input class="rp-compare-check" ' +
        'type="checkbox" ' +
        'data-row-id="' +
        escapeHTML(id) +
        '"' +
        checked +
        ' aria-label="Compare this axle">'
      );
    }

    if (column.type === "status") {
      return makeStatusPill(value);
    }

    if (column.type === "qty" && value) {
      return makeQty(value);
    }

    if (column.type === "capacity") {
      var specs = getSpecs(row);

      return specs.capacity
        ? escapeHTML(
            Number(specs.capacity).toLocaleString() +
            " lb"
          )
        : escapeHTML(value);
    }

    if (column.type === "price" && value) {
      var price = formatPrice(value);

      return price
        ? escapeHTML(price)
        : "";
    }

    if (column.type === "title") {
      var detailId = rowId(row, rowIndex);

      var buttonText = openDetails[detailId]
        ? "Hide Specifications"
        : "View Specifications";

      return (
        escapeHTML(value) +
        makeSpecBadges(row) +
        '<button type="button" ' +
        'class="rp-detail-button" ' +
        'data-detail-id="' +
        escapeHTML(detailId) +
        '">' +
        buttonText +
        "</button>"
      );
    }

    if (column.type === "notes") {
      return escapeHTML(value);
    }

    if (
      column.type === "link" &&
      isURL(value)
    ) {
      var href = cleanCell(value);

      if (/^www\./i.test(href)) {
        href = "https://" + href;
      }

      return (
        '<a class="rp-fb-link" ' +
        'href="' +
        escapeHTML(href) +
        '" target="_blank" ' +
        'rel="noopener">' +
        "Open on FB" +
        "</a>"
      );
    }

    return escapeHTML(value);
  }

  function makeDetailRow(row, rowIndex) {
    var title = getPrimaryTitle(row);
    var sku = findValue(row, publicColumns[5]);
    var notes = findValue(row, publicColumns[6]);

    var price = formatPrice(
      findValue(row, publicColumns[7])
    );

    var specs = getSpecs(row);

    var sourcePlatform = findAliasValue(
      row,
      sourceColumns.platform
    );

    var sourceRecord = findAliasValue(
      row,
      sourceColumns.record
    );

    var dexterNumber = findAliasValue(
      row,
      sourceColumns.dexter
    );

    var invoiceNumber = findAliasValue(
      row,
      sourceColumns.invoice
    );

    var invoiceDate = findAliasValue(
      row,
      sourceColumns.invoiceDate
    );

    var batchDate = findAliasValue(
      row,
      sourceColumns.batchDate
    );

    var verifiedDate = findAliasValue(
      row,
      sourceColumns.verified
    );

    var shopifyUrl = findAliasValue(
      row,
      sourceColumns.shopify
    );

    var ebayUrl = findAliasValue(
      row,
      sourceColumns.ebay
    );

    var facebookUrl = findValue(
      row,
      publicColumns[8]
    );

    var sourceLinks = [];

    if (isURL(facebookUrl)) {
      sourceLinks.push(
        '<a href="' +
        escapeHTML(facebookUrl) +
        '" target="_blank" rel="noopener">' +
        "Facebook listing" +
        "</a>"
      );
    }

    if (isURL(shopifyUrl)) {
      sourceLinks.push(
        '<a href="' +
        escapeHTML(shopifyUrl) +
        '" target="_blank" rel="noopener">' +
        "Shopify listing" +
        "</a>"
      );
    }

    if (isURL(ebayUrl)) {
      sourceLinks.push(
        '<a href="' +
        escapeHTML(ebayUrl) +
        '" target="_blank" rel="noopener">' +
        "eBay listing" +
        "</a>"
      );
    }

    var contactBody = encodeURIComponent(
      "I am interested in this axle: " +
      title +
      " / SKU: " +
      sku +
      " / Listed price: " +
      (price || "Call to confirm")
    );

    return (
      '<tr class="rp-detail-row">' +
        '<td colspan="' +
        publicColumns.length +
        '">' +
          '<div class="rp-detail-inner">' +

            '<div class="rp-detail-box">' +
              "<strong>Fitment Snapshot</strong>" +
              "<p>" +
                makeSpecBadges(row) +
              "</p>" +
            "</div>" +

            '<div class="rp-detail-box">' +
              "<strong>Listing Details</strong>" +
              "<p>" +
                "<b>Title:</b> " +
                escapeHTML(title) +
                "<br>" +
                "<b>SKU:</b> " +
                escapeHTML(
                  sku || "Call to confirm"
                ) +
                "<br>" +
                "<b>Price:</b> " +
                escapeHTML(
                  price || "Call to confirm"
                ) +
              "</p>" +
            "</div>" +

            '<div class="rp-detail-box rp-detail-price-box">' +
              '<strong class="rp-detail-price-label">' +
                "Current Listed Price" +
              "</strong>" +

              '<span class="rp-detail-price-value">' +
                escapeHTML(
                  price || "Call to Confirm"
                ) +
              "</span>" +

              '<span class="rp-detail-price-note">' +
                "Listed price when available. " +
                "Confirm availability, pickup timing, " +
                "and fitment before purchase." +
              "</span>" +

              '<a class="rp-price-secondary-link" ' +
              'href="/pages/contact-us?contact%5Bbody%5D=' +
              contactBody +
              '">' +
                "Send fitment details &rarr;" +
              "</a>" +
            "</div>" +

            '<div class="rp-detail-box">' +
              "<strong>Decoded Specs</strong>" +
              "<p>" +
                "<b>Capacity:</b> " +
                escapeHTML(
                  specs.capacity
                    ? Number(specs.capacity).toLocaleString() +
                      " lb"
                    : "Verify"
                ) +
                "<br>" +

                "<b>Hub Face:</b> " +
                escapeHTML(
                  specs.hub || "Verify"
                ) +
                "<br>" +

                "<b>Spring Center:</b> " +
                escapeHTML(
                  specs.spring || "Verify"
                ) +
                "<br>" +

                "<b>Type:</b> " +
                escapeHTML(
                  specs.type || "Verify"
                ) +
                "<br>" +

                "<b>Brake:</b> " +
                escapeHTML(
                  specs.brake || "Verify"
                ) +
                "<br>" +

                "<b>Bolt Pattern:</b> " +
                escapeHTML(
                  specs.bolt || "Verify"
                ) +
              "</p>" +
            "</div>" +

            '<div class="rp-detail-box" ' +
            'style="grid-column:span 2;">' +
              "<strong>Notes / Decode</strong>" +
              "<p>" +
                escapeHTML(
                  notes ||
                  "No additional notes listed."
                ) +
              "</p>" +
            "</div>" +

            '<div class="rp-detail-box" ' +
            'style="grid-column:span 2;">' +
              "<strong>Source Information</strong>" +
              "<p>" +

                "<b>Source:</b> " +
                escapeHTML(
                  sourcePlatform ||
                  "Internal inventory record"
                ) +
                "<br>" +

                "<b>Source record:</b> " +
                escapeHTML(
                  sourceRecord || "Not recorded"
                ) +
                "<br>" +

                "<b>Dexter / original part number:</b> " +
                escapeHTML(
                  dexterNumber || "Not recorded"
                ) +
                "<br>" +

                "<b>Invoice:</b> " +
                escapeHTML(
                  invoiceNumber || "Not recorded"
                ) +
                "<br>" +

                "<b>Invoice date:</b> " +
                escapeHTML(
                  invoiceDate || "Not recorded"
                ) +
                "<br>" +

                "<b>Data batch:</b> " +
                escapeHTML(
                  batchDate || "Not recorded"
                ) +
                "<br>" +

                "<b>Last verified:</b> " +
                escapeHTML(
                  verifiedDate || "Not recorded"
                ) +

                (
                  sourceLinks.length
                    ? "<br><b>Listings:</b> " +
                      sourceLinks.join(" &middot; ")
                    : ""
                ) +

              "</p>" +
            "</div>" +

          "</div>" +
        "</td>" +
      "</tr>"
    );
  }

  function renderTable(filteredRows) {
    tableHead.innerHTML = "";
    tableBody.innerHTML = "";

    var headRow = document.createElement("tr");

    publicColumns.forEach(function(column, index){
      var th = document.createElement("th");
      var indicator = "";

      if (sortState.index === index) {
        indicator =
          sortState.direction === "asc"
            ? " &#9650;"
            : " &#9660;";
      }

      th.innerHTML =
        escapeHTML(column.label) +
        '<span class="rp-sort-indicator">' +
        indicator +
        "</span>";

      th.setAttribute("scope", "col");

      if (column.type !== "compare") {
        th.addEventListener("click", function(){
          if (sortState.index === index) {
            sortState.direction =
              sortState.direction === "asc"
                ? "desc"
                : "asc";
          } else {
            sortState.index = index;
            sortState.direction = "asc";
          }

          render();
        });
      }

      headRow.appendChild(th);
    });

    tableHead.appendChild(headRow);

    filteredRows.forEach(function(row){
      var originalIndex = rows.indexOf(row);
      var tr = document.createElement("tr");

      publicColumns.forEach(function(column){
        var td = document.createElement("td");
        var value = findValue(row, column);

        td.innerHTML = renderCellValue(
          column,
          value,
          row,
          originalIndex
        );

        tr.appendChild(td);
      });

      tableBody.appendChild(tr);

      var id = rowId(row, originalIndex);

      if (openDetails[id]) {
        tableBody.insertAdjacentHTML(
          "beforeend",
          makeDetailRow(row, originalIndex)
        );
      }
    });

    bindDynamicControls();
  }

  function renderCards(filteredRows) {
    cards.innerHTML = "";

    filteredRows.slice(0, 20).forEach(function(row){
      var originalIndex = rows.indexOf(row);
      var id = rowId(row, originalIndex);

      var card = document.createElement("div");
      card.className = "rp-axles-card";

      var top = document.createElement("div");
      top.className = "rp-axles-card-top";

      var title = document.createElement("h3");
      title.className = "rp-axles-card-title";
      title.textContent = getPrimaryTitle(row);

      var status = findValue(row, publicColumns[1]);

      var statusWrap = document.createElement("div");
      statusWrap.innerHTML = makeStatusPill(status);

      top.appendChild(title);
      top.appendChild(statusWrap);
      card.appendChild(top);

      var specs = document.createElement("div");
      specs.innerHTML = makeSpecBadges(row);
      card.appendChild(specs);

      var meta = document.createElement("div");
      meta.className = "rp-axles-card-meta";

      var mobileOrder = [2, 7, 3, 5, 8];

      mobileOrder.forEach(function(index){
        var column = publicColumns[index];
        var value = findValue(row, column);

        if (!value) {
          return;
        }

        var rendered = renderCellValue(
          column,
          value,
          row,
          originalIndex
        );

        if (!rendered) {
          return;
        }

        var line = document.createElement("div");
        line.className = "rp-axles-card-row";

        var label = document.createElement("div");
        label.className = "rp-axles-card-label";
        label.textContent = column.label;

        var val = document.createElement("div");
        val.className = "rp-axles-card-value";
        val.innerHTML = rendered;

        line.appendChild(label);
        line.appendChild(val);
        meta.appendChild(line);
      });

      var compareLine = document.createElement("div");
      compareLine.className = "rp-axles-card-row";

      compareLine.innerHTML =
        '<div class="rp-axles-card-label">' +
          "Compare" +
        "</div>" +
        '<div class="rp-axles-card-value">' +
          '<input class="rp-compare-check" ' +
          'type="checkbox" ' +
          'data-row-id="' +
          escapeHTML(id) +
          '"' +
          (
            selectedCompareIds.indexOf(id) !== -1
              ? " checked"
              : ""
          ) +
          ">" +
        "</div>";

      meta.appendChild(compareLine);
      card.appendChild(meta);

      var call = document.createElement("div");
      call.className = "rp-card-call";

      var cardPrice = formatPrice(
        findValue(row, publicColumns[7])
      );

      var cardTitle = getPrimaryTitle(row);
      var cardSku = findValue(row, publicColumns[5]);

      var cardContactBody = encodeURIComponent(
        "I am interested in this axle: " +
        cardTitle +
        " / SKU: " +
        cardSku +
        " / Listed price: " +
        (cardPrice || "Call to confirm")
      );

      call.innerHTML =
        '<div class="rp-card-price-box">' +

          '<span class="rp-card-price-label">' +
            "Current Listed Price" +
          "</span>" +

          '<span class="rp-card-price-value">' +
            escapeHTML(
              cardPrice || "Call to Confirm"
            ) +
          "</span>" +

          '<span class="rp-card-price-note">' +
            "Confirm availability, pickup timing, " +
            "and fitment before purchase." +
          "</span>" +

          '<a href="/pages/contact-us?' +
          "contact%5Bbody%5D=" +
          cardContactBody +
          '" class="rp-price-secondary-link">' +
            "Send fitment details &rarr;" +
          "</a>" +

        "</div>";

      card.appendChild(call);
      cards.appendChild(card);
    });

    bindDynamicControls();
  }

  function updateStats(filteredRows) {
    var resultWord =
      filteredRows.length === 1
        ? "Axle Found"
        : "Axles Found";

    count.textContent =
      filteredRows.length +
      " " +
      resultWord;
  }

  function updateTimestamp() {
    if (!updated) {
      return;
    }

    var now = new Date();

    var formatted = now.toLocaleString([], {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit"
    });

    updated.textContent = formatted;
  }

  function updateCompareBar() {
    if (!compareBar || !compareCount) {
      return;
    }

    compareCount.textContent =
      selectedCompareIds.length +
      " axles selected";

    compareBar.hidden =
      selectedCompareIds.length === 0;
  }

  function findRowById(id) {
    for (var i = 0; i < rows.length; i++) {
      if (rowId(rows[i], i) === id) {
        return rows[i];
      }
    }

    return null;
  }

  function renderComparePanel() {
    if (!comparePanel || !compareTableWrap) {
      return;
    }

    var selectedRows = selectedCompareIds
      .map(findRowById)
      .filter(Boolean);

    if (!selectedRows.length) {
      comparePanel.hidden = true;
      return;
    }

    var fields = [
      {
        label: "Title",
        get: function(row){
          return getPrimaryTitle(row);
        }
      },
      {
        label: "Status",
        get: function(row){
          return makeStatusPill(
            findValue(row, publicColumns[1])
          );
        },
        html: true
      },
      {
        label: "Qty",
        get: function(row){
          return renderCellValue(
            publicColumns[2],
            findValue(row, publicColumns[2]),
            row,
            rows.indexOf(row)
          );
        },
        html: true
      },
      {
        label: "Capacity",
        get: function(row){
          var specs = getSpecs(row);

          return specs.capacity
            ? Number(specs.capacity).toLocaleString() +
              " lb"
            : "Verify";
        }
      },
      {
        label: "Hub Face",
        get: function(row){
          return getSpecs(row).hub || "Verify";
        }
      },
      {
        label: "Spring Center",
        get: function(row){
          return getSpecs(row).spring || "Verify";
        }
      },
      {
        label: "Type",
        get: function(row){
          return getSpecs(row).type || "Verify";
        }
      },
      {
        label: "Brake",
        get: function(row){
          return getSpecs(row).brake || "Verify";
        }
      },
      {
        label: "Bolt Pattern",
        get: function(row){
          return getSpecs(row).bolt || "Verify";
        }
      },
      {
        label: "R&P SKU",
        get: function(row){
          return (
            findValue(row, publicColumns[5]) ||
            "Verify"
          );
        }
      },
      {
        label: "Price",
        get: function(row){
          return (
            formatPrice(
              findValue(row, publicColumns[7])
            ) ||
            "Call to confirm"
          );
        }
      }
    ];

    var html =
      '<table class="rp-compare-table">' +
      "<tbody>";

    fields.forEach(function(field){
      html +=
        "<tr><td>" +
        escapeHTML(field.label) +
        "</td>";

      selectedRows.forEach(function(row){
        var value = field.get(row);

        html +=
          "<td>" +
          (
            field.html
              ? value
              : escapeHTML(value)
          ) +
          "</td>";
      });

      html += "</tr>";
    });

    html +=
      "</tbody>" +
      "</table>";

    compareTableWrap.innerHTML = html;
    comparePanel.hidden = false;
  }

  function bindDynamicControls() {
    var checkboxes = document.querySelectorAll(
      ".rp-compare-check"
    );

    checkboxes.forEach(function(checkbox){
      checkbox.addEventListener(
        "change",
        function(){
          var id = checkbox.getAttribute(
            "data-row-id"
          );

          if (checkbox.checked) {
            if (
              selectedCompareIds.indexOf(id) === -1
            ) {
              if (selectedCompareIds.length >= 3) {
                checkbox.checked = false;
                return;
              }

              selectedCompareIds.push(id);
            }
          } else {
            selectedCompareIds =
              selectedCompareIds.filter(
                function(existingId){
                  return existingId !== id;
                }
              );
          }

          updateCompareBar();
        }
      );
    });

    var detailButtons = document.querySelectorAll(
      ".rp-detail-button"
    );

    detailButtons.forEach(function(button){
      button.addEventListener(
        "click",
        function(){
          var id = button.getAttribute(
            "data-detail-id"
          );

          openDetails[id] = !openDetails[id];

          render();
        }
      );
    });
  }

  function render() {
    var filteredRows = getFilteredRows();

    renderTable(filteredRows);
    renderCards(filteredRows);
    updateStats(filteredRows);
    updateCompareBar();

    if (noResults) {
      noResults.hidden =
        filteredRows.length !== 0;
    }
  }

  function loadInventory() {
    fetch(
      csvUrl +
      "&cacheBust=" +
      Date.now()
    )
      .then(function(response){
        if (!response.ok) {
          throw new Error(
            "Inventory fetch failed"
          );
        }

        return response.text();
      })
      .then(function(text){
        var csv = parseCSV(text).filter(
          function(row){
            return row.some(function(cell){
              return cleanCell(cell);
            });
          }
        );

        if (csv.length < 2) {
          throw new Error(
            "Inventory sheet is empty"
          );
        }

        var headerIndex = findHeaderRow(csv);

        rawHeaders = csv[headerIndex].map(
          cleanCell
        );

        rows = csv
          .slice(headerIndex + 1)
          .map(function(csvRow){
            var rowObject = {};

            rawHeaders.forEach(
              function(header, index){
                if (header) {
                  rowObject[header] = cleanCell(
                    csvRow[index]
                  );
                }
              }
            );

            return rowObject;
          })
          .filter(function(rowObject){
            return publicColumns.some(
              function(column){
                return findValue(
                  rowObject,
                  column
                );
              }
            );
          })
          .filter(shouldShowRow);

        populateStatusOptions();
        render();
        updateTimestamp();

        loading.hidden = true;
        error.hidden = true;
      })
      .catch(function(){
        loading.hidden = true;
        error.hidden = false;

        count.textContent =
          "Inventory unavailable";

        if (updated) {
          updated.textContent =
            "Please call to confirm availability.";
        }
      });
  }

  if (searchInput) {
    searchInput.addEventListener(
      "input",
      render
    );
  }

  if (statusFilter) {
    statusFilter.addEventListener(
      "change",
      render
    );
  }

  [
    finderCapacity,
    finderType,
    finderBrake,
    finderBolt,
    finderHubFace,
    finderSpringCenter
  ].forEach(function(input){
    if (!input) {
      return;
    }

    input.addEventListener(
      "input",
      render
    );

    input.addEventListener(
      "change",
      render
    );
  });

  if (finderReset) {
    finderReset.addEventListener(
      "click",
      function(){
        if (finderCapacity) {
          finderCapacity.value = "";
        }

        if (finderType) {
          finderType.value = "";
        }

        if (finderBrake) {
          finderBrake.value = "";
        }

        if (finderBolt) {
          finderBolt.value = "";
        }

        if (finderHubFace) {
          finderHubFace.value = "";
        }

        if (finderSpringCenter) {
          finderSpringCenter.value = "";
        }

        render();
      }
    );
  }

  chipButtons.forEach(function(button){
    button.addEventListener(
      "click",
      function(){
        var type = button.getAttribute(
          "data-chip-type"
        );

        var value = button.getAttribute(
          "data-chip-value"
        );

        if (!activeChips[type]) {
          activeChips[type] = [];
        }

        if (
          activeChips[type].indexOf(value) === -1
        ) {
          activeChips[type].push(value);
          button.classList.add("is-active");
        } else {
          activeChips[type] =
            activeChips[type].filter(
              function(existing){
                return existing !== value;
              }
            );

          button.classList.remove("is-active");
        }

        render();
      }
    );
  });

  if (clearChips) {
    clearChips.addEventListener(
      "click",
      function(){
        activeChips = {};

        chipButtons.forEach(function(button){
          button.classList.remove("is-active");
        });

        render();
      }
    );
  }

  if (compareOpen) {
    compareOpen.addEventListener(
      "click",
      renderComparePanel
    );
  }

  if (compareClear) {
    compareClear.addEventListener(
      "click",
      function(){
        selectedCompareIds = [];
        comparePanel.hidden = true;

        render();
      }
    );
  }

  if (compareClose) {
    compareClose.addEventListener(
      "click",
      function(){
        comparePanel.hidden = true;
      }
    );
  }

  loadInventory();
})();